import React, { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { getNumberWithUnit } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { getRegion, followFund, getSubspecialties, searchHedgeFund } from "./actions";
import { useQuery } from "../../utils/CustomHook";
import Funds from "../shared/Funds";
import { getStrategies, CreateRecommendedFund } from "./actions";
import { alertService } from "@hedgefund/shared/src/Alert";
import { createRoom, getAllocatorUsers } from "../FundDetail/actions";

export const aumData = [
  { option: "All", value: "all" },
  { option: "$0-25mm", value: "0-25000000" },
  { option: "$25mm-50mm", value: "25000000-50000000" },
  { option: "$50mm-100mm", value: "50000000-100000000" },
  { option: "$100mm-250mm", value: "100000000-250000000" },
  { option: "$250mm-500mm", value: "250000000-500000000" },
  { option: "$500mm-1bn", value: "500000000-1000000000" },
  { option: "$1bn- above", value: "Above 1000000000" },
];

export const monthlyReturn = [
  { option: "All", value: "all" },
  { option: "0%-10%", value: "0-10" },
  { option: "10%-25%", value: "10-25" },
  { option: "25%-50%", value: "25-50" },
  { option: "50%-75%", value: "50-75" },
  { option: "75%-100%", value: "75-100" },
  { option: "Above 100", value: "100-" },
];

const SearchHedgeFund = () => {
  const query = useQuery();
  const searchOptions = query.get("keyword") || "";
  const dropDownStrategyValue = query.get("dropDownValue") || null;
  const dropDownRegionValue = query.get("dropDownRegionValue") || null;
  const dropDownAumValue = query.get("dropDownAumValue") || null;
  const dropDownSubspecialtyValue = query.get("dropDownSubspecialtyValue") || null;


  const [page, setPage] = useState(1);
  const [firstCall, setFirstCall] = useState(true);
  const [strategyFilter, setStrategyFilter] = useState(dropDownStrategyValue);
  const [regionFilter, setRegionFilter] = useState(dropDownRegionValue);
  const [subSpecialtyFilter, setSubSpecialtyFilter] = useState(dropDownSubspecialtyValue);


  const [aum, setAum] = useState({
    min: "",
    max: "",
  });

  const [monthlyReturnValue, setMonthlyReturnValue] = useState({
    min: "",
    max: "",
  });
  const [filterStrategyShow, setFilterStrategyShow] = useState(false);
  const [filterAUMShow, setFilterAUMShow] = useState(false);
  const [filterMonthlyReturnShow, setFilterMonthlyReturnShow] = useState(false);
  const [filterRegionShow, setFilterRegionShow] = useState(false);
  const [searchValue, setSearchValue] = useState(searchOptions);
  const [filterSubSpecialtyShow, setFilterSubSpecialtyShow] = useState(false);

  const dispatch = useDispatch();
  const fundState = useSelector((state) => state.SearchHedgeFundStore);

  const regions = useSelector((state) => state.SearchHedgeFundStore.regions);

  const hedgeFundDetailState = useSelector((state) => state.hedgeFundDetailStore);

  const { allocatorUsers, userLoading } = hedgeFundDetailState;

  const dashboardState =
    useSelector(({ SearchHedgeFundStore }) => SearchHedgeFundStore.companyStrategyData) || [];

  const rmfundLoading = useSelector((state) => state.rmfundLoading);

  const subSpecialties =
    useSelector(({ SearchHedgeFundStore }) => SearchHedgeFundStore.subSpecialties) || [];

  const strategiesList = [
    {
      name: "All",
      isExistFund: false,
      creationTime: null,
      creatorUserId: null,
      id: 29,
    },
    ...dashboardState,
  ];

  const regionList = [
    {
      name: "All",
      id: 6,
    },
    ...regions,
  ];
  const subSpecialtyList = [
    {
      name: "All",
      isExistFund: false,
      creationTime: null,
      creatorUserId: null,
      id: 29,
    },
    ...subSpecialties,
  ];
  useEffect(() => {
    if (dropDownAumValue) {
      const result = aumData?.find(
        ({ option }) => option === (dropDownAumValue || "")
      );
      const { value } = result;
      if (value === "all") {
        setAum();
      } else if (value !== "all") {
        const splitNumbers = value?.split("-");
        const min = splitNumbers || "";
        const max = splitNumbers || "";
        setAum({
          min: min[0],
          max: max[1],
        });
        setFilterAUMShow({ value: dropDownAumValue, label: dropDownAumValue });
      }
    }
  }, [dropDownAumValue]);

  useEffect(() => {
    if (dropDownStrategyValue === "All") {
      setStrategyFilter();
    }
  }, [dropDownStrategyValue]);

  useEffect(() => {
    if (dropDownRegionValue === "All") {
      setRegionFilter();
    }
  }, [dropDownRegionValue]);
  useEffect(() => {
    if (dropDownSubspecialtyValue === "All") {
      setSubSpecialtyFilter();
    }
  }, [dropDownSubspecialtyValue]);
  useEffect(() => {
    dispatch(getStrategies());
    setFirstCall(false);
    dispatch(getRegion());
    dispatch(getSubspecialties());
    // loadData();
  }, []);

  useEffect(() => {
    if (!firstCall) {
      loadData();
    }
  }, []);

  useEffect(() => {
    if (!firstCall) {
      loadData();
    }
  }, [page]);

  useEffect(() => {
    setPage(1);

    loadData();
  }, [searchValue, strategyFilter, subSpecialtyFilter, aum, regionFilter, monthlyReturnValue]);

  const handleSearch = debounce((text) => {
    setSearchValue(text);
  }, 1500);

  const loadData = () => {
    dispatch(
      searchHedgeFund({
        page: page,
        limit: 20,
        strategy: strategyFilter ? strategyFilter : "",
        subSpecialty: subSpecialtyFilter ? subSpecialtyFilter : "",
        region: regionFilter ? regionFilter : "",
        keyword: searchValue ? searchValue : "",
        min: aum?.min ? aum?.min : "",
        max: aum?.max ? aum?.max : "",
        minMonthlyReturn: monthlyReturnValue?.min ?? "",
        maxMonthlyReturn: monthlyReturnValue?.max
          ? monthlyReturnValue?.max
          : "",
        sortBy: 2,
        sortByColumn: "AUM"
      })
    );
  };

  const onClickCrossStrategyHandler = () => {
    setStrategyFilter([]);
    dispatch(getSubspecialties())
    setFilterStrategyShow(!filterStrategyShow);
  };

  const onClickCrossAumHandler = () => {
    setFilterAUMShow(false);
    setAum({ min: "", max: "" });
  };

  const onClickCrossMonthlyReturnHandler = () => {
    setFilterMonthlyReturnShow(false);
    setMonthlyReturnValue({ min: "", max: "" });
  };

  const onClickCrossRegionHandler = () => {
    setFilterRegionShow(false);
    setRegionFilter([]);
  };

  const onClickCrossSubSpecialtyHandler = () => {
    setSubSpecialtyFilter([]);
    setFilterSubSpecialtyShow(!filterSubSpecialtyShow);
  };

  const onChangeFilterData = (e) => {
    let num = 29;
    if (e.value === num) {
      setStrategyFilter();
      dispatch(getSubspecialties())
      setFilterStrategyShow(false);
    } else {
      setStrategyFilter(e.value);
      dispatch(getSubspecialties());
      setFilterStrategyShow(true);
    }
  };

  const onChangeAumDataHandle = (e) => {
    const { value } = aumData.find(({ option }) => e.label === option);
    if (value === "all") {
      setFilterAUMShow(false);
      setAum({ min: "", max: "" });
    } else if (value === "Above 1000000000") {
      const values = value.split(" ");
      const min = values[1];
      setAum({
        min: parseInt(min),
      });

      setFilterAUMShow(e);
    }
    else if (value !== "all") {
      const values = value.split("-");
      const min = values[0];
      const max = values[1];

      setAum({
        min: parseInt(min),
        max: parseInt(max),
      });

      setFilterAUMShow(e);
    }
  };

  const onChangeMonthlyReturn = (e) => {
    const { value } = monthlyReturn.find(({ option }) => e.label === option);
    if (value === "all") {
      setFilterMonthlyReturnShow(false);
      setMonthlyReturnValue({ min: "", max: "" });
    } else if (value !== "all") {
      const values = value.split("-");
      const min = values[0];
      const max = values[1];

      setMonthlyReturnValue({
        min: +min,
        max: +max,
      });

      setFilterMonthlyReturnShow(e);
    }
  };

  const onChangeRegionDataHandler = (e) => {
    let num = 6;
    if (e.value === num) {
      setRegionFilter();
      setFilterRegionShow(false);
    } else {
      setRegionFilter(e.value);
      setFilterRegionShow(true);
    }
  };


  const onChangeSubSpecialtyFilterData = (e) => {
    let num = 29;
    if (e.value === num) {
      setSubSpecialtyFilter();
      setFilterSubSpecialtyShow(false);
    } else {
      setSubSpecialtyFilter(e.value);
      setFilterSubSpecialtyShow(true);
    }
  };

  const followFundHandler = (fundId, follow) => {
    dispatch(followFund(fundId, follow));
  };
  const CreateRecommendFund = (values, onModalClose) => {
    dispatch(CreateRecommendedFund(values, onSuccess, onModalClose));
  }
  const onSuccess = () => {
    alertService.success("Recommended Fund Successfully Added.", true)
  }
  const getAllocatorUserList = (id) => {
    dispatch(getAllocatorUsers(id));
  }
  const createAllocatorRoom = (body, callback) => {
    dispatch(createRoom(body, callback))
  }
  return (
    <Funds
      searchValue={searchValue}
      handleSearch={handleSearch}
      filterStrategyShow={filterStrategyShow}
      dashboardState={strategiesList}
      strategyFilter={strategyFilter}
      CreateRecommendFund={CreateRecommendFund}
      rmfundLoading={rmfundLoading}
      onClickCrossStrategyHandler={onClickCrossStrategyHandler}
      onClickCrossAumHandler={onClickCrossAumHandler}
      onChangeFilterData={onChangeFilterData}
      aumData={aumData}
      fundState={fundState}
      getNumberWithUnit={getNumberWithUnit}
      onChangeAumData={onChangeAumDataHandle}
      filterAUMShow={filterAUMShow}
      aum={aum}
      regionDropDown={regionList}
      onChangeReigionData={onChangeRegionDataHandler}
      followFundHandler={followFundHandler}
      defaultValue={dropDownAumValue}
      filterRegionShow={filterRegionShow}
      onClickCrossRegionHandler={onClickCrossRegionHandler}
      regionFilter={regionFilter}
      onClickNext={() => setPage(page + 1)}
      monthlyReturn={monthlyReturn}
      onChangeMonthlyReturn={onChangeMonthlyReturn}
      filterMonthlyReturnShow={filterMonthlyReturnShow}
      onClickCrossMonthlyReturnHandler={onClickCrossMonthlyReturnHandler}
      subSpecialtyDropDown={subSpecialtyList}
      onChangeSubSpecialtyFilterData={onChangeSubSpecialtyFilterData}
      filterSubSpecialtyShow={filterSubSpecialtyShow}
      onClickCrossSubSpecialtyHandler={onClickCrossSubSpecialtyHandler}
      subSpecialtyFilter={subSpecialtyFilter}
      userLoading={userLoading}
      allocatorUsers={allocatorUsers}
      getAllocatorUsers={getAllocatorUserList}
      createRoom={createAllocatorRoom}
    />
  );
};

export default SearchHedgeFund;
